import React from 'react';

interface CompanyIconProps {
	className?: string;
}

export const CompanyIcon: React.FC<CompanyIconProps> = ({ className }) => (
	<svg 
		width="82" 
		height="82" 
		viewBox="0 0 33 33" 
		fill="none" 
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path d="M13.3007 9.10254H6.91406V11.1025H13.3007V9.10254Z" fill="currentColor"/>
		<path d="M13.3007 14.0088H6.91406V16.0088H13.3007V14.0088Z" fill="currentColor"/>
		<path d="M27.0078 21.1816H20.6211V23.1816H27.0078V21.1816Z" fill="currentColor"/>
		<path 
			d="M27.912 14.0085H19.4854C19.0854 14.0085 18.712 14.0885 18.3787 14.2085V4.52848C18.3787 2.95514 17.0187 1.68848 15.352 1.68848H4.8587C3.19203 1.68848 1.83203 2.95514 1.83203 4.52848V27.5551C1.83203 29.1285 3.19203 30.3951 4.8587 30.3951H27.912C29.712 30.3951 31.1654 29.0351 31.1654 27.3418V17.0618C31.1654 15.3818 29.712 14.0085 27.912 14.0085ZM16.3654 27.6218C16.3654 28.0351 16.0187 28.3685 15.5787 28.3685H11.912V23.2085H7.87203V28.3685H4.6187C4.1787 28.3685 3.83203 28.0351 3.83203 27.6218V4.43514C3.83203 4.02181 4.1787 3.68848 4.6187 3.68848H15.592C16.032 3.68848 16.3787 4.02181 16.3787 4.43514V27.6218H16.3654ZM29.1654 27.4085C29.1654 27.9285 28.712 28.3551 28.152 28.3551H19.4854C18.9254 28.3551 18.472 27.9285 18.472 27.4085V16.9685C18.472 16.4485 18.9254 16.0218 19.4854 16.0218H28.152C28.712 16.0218 29.1654 16.4485 29.1654 16.9685V27.4085Z" 
			fill="currentColor"
		/>
	</svg>
);